<template>
  <div v-if="checkout_status">

    <form class="program__signup-form" @submit.prevent="paymentForm__submit" >
      <input type="hidden" name="passed_payment_id" :value="checkout_status.parent.document_id" />

      <h1 class="program__top-title" v-html="design.title"></h1>
      <div class="program__top-text" v-html="design.intro"></div>
      <div class="program__top-price">${{program.price.toFixed(2)}} <span style="font-size: 0.9em;">{{ program.payment_type_text }}</span></div>

      <div class="program__card-elements" id="card-elements"></div>

      <div class="program__complete-button-container">
        <button class="button button--fill button--square program__complete-button" :disabled="is_submitting_payment">Complete Sign Up</button>
        <svg class="program__card-secure-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 801.05 84.13"><path d="M551.14,33.41h-.03v-7.56c0-14.28-11.57-25.85-25.85-25.85h-.64c-14.28,0-25.85,11.57-25.85,25.85v7.56c-1.82,.05-3.29,1.53-3.29,3.36v17.85c0,16.29,13.21,29.5,29.5,29.5h.02c16.29,0,29.5-13.21,29.5-29.5v-17.85c0-1.86-1.51-3.37-3.37-3.37Zm-43.48-6.97c0-9.57,7.76-17.33,17.33-17.33s17.33,7.76,17.33,17.33v6.96h-34.66v-6.96Zm36.57,22.38l-21.39,19.94c-.4,.37-1.01,.37-1.41,0l-12.99-12.35c-.41-.39-.43-1.04-.04-1.45l4.71-4.99c.39-.41,1.04-.43,1.45-.04l6.94,6.55c.39,.37,1.01,.37,1.41,0l15.22-14.14c.41-.39,1.06-.37,1.45,.04l4.7,4.98c.39,.41,.37,1.06-.04,1.45Z"/><g><path d="M115.84,3.36v7.92c-3-2.16-7.26-3.42-10.92-3.42-4.14,0-7.32,1.8-7.32,5.1,0,3.06,2.7,4.5,7.86,6.66,6.48,2.7,12.96,5.52,12.96,13.68s-6.6,13.68-15.9,13.68c-5.46,0-10.32-1.92-13.26-4.08v-8.46c3.12,2.94,7.92,5.04,12.54,5.04s7.98-2.22,7.98-5.88c0-3.36-3.18-4.98-8.46-7.26-5.88-2.46-12.06-5.34-12.06-13.02S95.5,.36,104.5,.36c4.44,0,8.46,1.26,11.34,3Z"/><path d="M126.22,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/><path d="M181.48,46.98c-12.12,0-22.74-9.18-22.74-23.34S169.36,.3,181.48,.3c5.16,0,9.06,1.38,12.12,3.06V11.82c-3.54-2.34-6.84-3.66-11.34-3.66-7.86,0-14.94,5.94-14.94,15.48s7.08,15.54,14.94,15.54c4.5,0,7.8-1.5,11.34-3.84v8.58c-3.06,1.68-6.96,3.06-12.12,3.06Z"/><path d="M201.1,28.62V1.32h8.4V28.74c0,6.6,3.6,10.5,9.48,10.5s9.84-3.9,9.84-10.56V1.32h8.4V28.62c0,10.8-7.02,18.42-18.24,18.42s-17.88-7.62-17.88-18.42Z"/><path d="M247.24,1.32h13.38c10.68,0,16.98,5.28,16.98,14.1,0,5.94-3.36,11.88-12.36,13.62l14.4,16.98h-10.26l-13.26-16.5h-.48v16.5h-8.4V1.32Zm12.84,21.6c6.06,0,9-2.7,9-7.02s-3.24-6.9-8.7-6.9h-4.74v13.92h4.44Z"/><path d="M286.24,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/></g><g><path d="M100.47,63.23v3.51c-1.33-.96-3.22-1.52-4.84-1.52-1.84,0-3.25,.8-3.25,2.26,0,1.36,1.2,1.99,3.48,2.95,2.87,1.2,5.74,2.45,5.74,6.06s-2.93,6.06-7.05,6.06c-2.42,0-4.57-.85-5.88-1.81v-3.75c1.38,1.3,3.51,2.23,5.56,2.23s3.54-.98,3.54-2.61c0-1.49-1.41-2.21-3.75-3.22-2.61-1.09-5.35-2.37-5.35-5.77s2.77-5.75,6.76-5.75c1.97,0,3.75,.56,5.03,1.33Z"/><path d="M116.06,63.23v3.51c-1.33-.96-3.22-1.52-4.84-1.52-1.84,0-3.25,.8-3.25,2.26,0,1.36,1.2,1.99,3.48,2.95,2.87,1.2,5.74,2.45,5.74,6.06s-2.93,6.06-7.05,6.06c-2.42,0-4.57-.85-5.88-1.81v-3.75c1.38,1.3,3.51,2.23,5.56,2.23s3.54-.98,3.54-2.61c0-1.49-1.41-2.21-3.75-3.22-2.61-1.09-5.35-2.37-5.35-5.77s2.77-5.75,6.76-5.75c1.97,0,3.75,.56,5.03,1.33Z"/><path d="M120.66,62.33h3.72v16.38h8.38v3.43h-12.1v-19.81Z"/><path d="M141.81,62.33h11.94v3.38h-8.22v4.81h7.53v3.14h-7.53v5.11h8.22v3.38h-11.94v-19.81Z"/><path d="M174.34,82.14h-3.51l-9.52-13.88h-.03v13.88h-3.59v-19.81h3.64l9.39,13.62h.03v-13.62h3.59v19.81Z"/><path d="M187.93,82.57c-5.37,0-10.08-4.07-10.08-10.35s4.71-10.35,10.08-10.35c2.29,0,4.02,.61,5.37,1.36v3.75c-1.57-1.04-3.03-1.62-5.03-1.62-3.48,0-6.62,2.63-6.62,6.86s3.14,6.89,6.62,6.89c2,0,3.46-.67,5.03-1.7v3.8c-1.36,.74-3.08,1.36-5.37,1.36Z"/><path d="M196.87,62.33h5.93c4.73,0,7.53,2.34,7.53,6.25,0,2.63-1.49,5.27-5.48,6.04l6.38,7.53h-4.55l-5.88-7.31h-.21v7.31h-3.72v-19.81Zm5.69,9.57c2.69,0,3.99-1.2,3.99-3.11s-1.44-3.06-3.86-3.06h-2.1v6.17h1.97Z"/><path d="M218.36,74.08l-7.34-11.76h4.18l5.05,8.4h.08l5-8.4h4.02l-7.29,11.73v8.08h-3.7v-8.06Z"/><path d="M231.77,62.33h5.53c5.21,0,8.33,2.58,8.33,6.78s-2.98,7.07-8.14,7.07h-2v5.96h-3.72v-19.81Zm5.9,10.48c2.5,0,4.2-1.3,4.2-3.56s-1.7-3.51-4.23-3.51h-2.15v7.07h2.18Z"/><path d="M252.97,65.73h-5.96v-3.4h15.61v3.4h-5.93v16.41h-3.72v-16.41Z"/><path d="M265.52,62.33h3.72v19.81h-3.72v-19.81Z"/><path d="M282.89,61.87c5.74,0,10.08,4.39,10.08,10.35s-4.33,10.37-10.08,10.37-10.13-4.39-10.13-10.37,4.36-10.35,10.13-10.35Zm6.3,10.35c0-4.36-3.08-6.89-6.3-6.89s-6.33,2.53-6.33,6.89,3.06,6.92,6.33,6.92,6.3-2.53,6.3-6.92Z"/><path d="M313.14,82.14h-3.51l-9.52-13.88h-.03v13.88h-3.59v-19.81h3.64l9.39,13.62h.03v-13.62h3.59v19.81Z"/></g><g><path d="M603.71,3.36v7.92c-3-2.16-7.26-3.42-10.92-3.42-4.14,0-7.32,1.8-7.32,5.1,0,3.06,2.7,4.5,7.86,6.66,6.48,2.7,12.96,5.52,12.96,13.68s-6.6,13.68-15.9,13.68c-5.46,0-10.32-1.92-13.26-4.08v-8.46c3.12,2.94,7.92,5.04,12.54,5.04s7.98-2.22,7.98-5.88c0-3.36-3.18-4.98-8.46-7.26-5.88-2.46-12.06-5.34-12.06-13.02s6.24-12.96,15.24-12.96c4.44,0,8.46,1.26,11.34,3Z"/><path d="M614.09,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/><path d="M669.35,46.98c-12.12,0-22.74-9.18-22.74-23.34S657.23,.3,669.35,.3c5.16,0,9.06,1.38,12.12,3.06V11.82c-3.54-2.34-6.84-3.66-11.34-3.66-7.86,0-14.94,5.94-14.94,15.48s7.08,15.54,14.94,15.54c4.5,0,7.8-1.5,11.34-3.84v8.58c-3.06,1.68-6.96,3.06-12.12,3.06Z"/><path d="M688.97,28.62V1.32h8.4V28.74c0,6.6,3.6,10.5,9.48,10.5s9.84-3.9,9.84-10.56V1.32h8.4V28.62c0,10.8-7.02,18.42-18.24,18.42s-17.88-7.62-17.88-18.42Z"/><path d="M735.11,1.32h13.38c10.68,0,16.98,5.28,16.98,14.1,0,5.94-3.36,11.88-12.36,13.62l14.4,16.98h-10.26l-13.26-16.5h-.48v16.5h-8.4V1.32Zm12.84,21.6c6.06,0,9-2.7,9-7.02s-3.24-6.9-8.7-6.9h-4.74v13.92h4.44Z"/><path d="M774.11,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/></g><g><path d="M577.36,62.33h5.53c5.21,0,8.32,2.58,8.32,6.78s-2.98,7.07-8.14,7.07h-2v5.96h-3.72v-19.81Zm5.9,10.48c2.5,0,4.2-1.3,4.2-3.56s-1.7-3.51-4.23-3.51h-2.15v7.07h2.18Z"/><path d="M606.4,82.14l-1.94-5.21h-7.77l-1.91,5.21h-3.88l7.53-19.81h4.28l7.61,19.81h-3.91Zm-3.03-8.35l-2.82-7.53-2.79,7.53h5.61Z"/><path d="M615.69,74.08l-7.34-11.76h4.18l5.05,8.4h.08l5-8.4h4.02l-7.29,11.73v8.08h-3.7v-8.06Z"/><path d="M630.34,82.14h-3.59l2.93-19.81h4.42l4.63,14.15h.03l4.5-14.15h4.39l2.9,19.81h-3.62l-1.89-14.65h-.08l-4.71,14.65h-3.22l-4.68-14.57h-.08l-1.92,14.57Z"/><path d="M653.99,62.33h11.94v3.38h-8.22v4.81h7.53v3.14h-7.53v5.11h8.22v3.38h-11.94v-19.81Z"/><path d="M686.52,82.14h-3.51l-9.52-13.88h-.03v13.88h-3.59v-19.81h3.64l9.39,13.62h.03v-13.62h3.59v19.81Z"/><path d="M695.38,65.73h-5.96v-3.4h15.61v3.4h-5.93v16.41h-3.72v-16.41Z"/></g><path d="M60.08,3.46C52.04,2.19,39.1,.31,33.47,.31S14.9,2.19,6.86,3.46C2.91,4.08,0,7.48,0,11.48V53.48c0,1.4,.55,2.74,1.53,3.73,2.77,2.79,18.6,17.17,26.89,24.67,2.87,2.6,7.23,2.6,10.1,0,8.3-7.51,24.17-21.92,26.89-24.67,.98-.99,1.53-2.33,1.53-3.73V11.48c0-4-2.91-7.4-6.86-8.03Zm-3.73,27.06l-25.98,24.22c-.48,.45-1.23,.45-1.71,0l-15.78-14.99c-.5-.47-.52-1.26-.05-1.76l5.72-6.05c.47-.5,1.26-.52,1.76-.05l8.43,7.96c.48,.45,1.23,.45,1.71,0l18.48-17.18c.5-.47,1.29-.45,1.76,.05l5.71,6.05c.47,.5,.45,1.29-.05,1.76Z"/></svg>
      </div>


      <div class="program__card-errors" v-if="stripe_error.length > 1">
        {{ stripe_error }}
      </div>
      <div class="program__card-errors" v-else-if="processing_error.length > 1">
        {{ processing_error }}
        <br />
        <div style="color:#666; padding-top:8px;">Please give Ash a call on <a href="tel:0410121754">0410 121 754</a> if your experiencing payment issues.</div>
      </div>
      <div v-else-if="is_submitting_payment" >
        <div class='loading-bar program__loading-bar'>
          <div class='loading-bar__step'></div>
        </div>

        <div class="program__payment-message program__payment-message--italic">{{ checkout_status.message }}</div>
      </div>

    </form>

  </div>

  <!--
  <div v-if="checkout_status">

    <form class="program__signup-form" @submit.prevent="paymentForm__submit" >
      <input type="hidden" name="passed_payment_id" :value="checkout_status.parent.document_id" />


      <div class="program__content" v-html="design.contents[0]" v-if="payment.has_successful_payment == false"></div>

      <div class="program__price" v-if="payment.has_successful_payment == false">${{ program.price }} <span style="font-size: 0.9em;">{{ program.payment_type_text }}</span></div>

      <! - -
      <div class="program__error-message" v-if="error_message.length > 0">{{ error_message }}</div>
      - - >

  <div class="program__card-elements" id="card-elements" v-if="payment.has_successful_payment == false"></div>

  < ! - - <div class="program__card-elements" id="card-elements" :class="{ 'program__card-elements--hide': !payment.ready_to_confirm_payment}"></div> - - >

  <div class="program__card-errors" v-if="stripe_card_error.length > 1">a: {{ stripe_card_error }}</div>

  <div v-if="payment.has_successful_payment">
    <h3 class="program__payment-heading">Thank you</h3>
    <div class="program__payment-message">We have sent you an email. Click the provided link to start your membership.</div>
  </div>

  <div class="program__complete-button-container" v-else-if="is_submitting_payment == false">
    <button class="button button--fill button--square program__complete-button">Complete Sign Up</button>
    <svg class="program__card-secure-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 801.05 84.13"><path d="M551.14,33.41h-.03v-7.56c0-14.28-11.57-25.85-25.85-25.85h-.64c-14.28,0-25.85,11.57-25.85,25.85v7.56c-1.82,.05-3.29,1.53-3.29,3.36v17.85c0,16.29,13.21,29.5,29.5,29.5h.02c16.29,0,29.5-13.21,29.5-29.5v-17.85c0-1.86-1.51-3.37-3.37-3.37Zm-43.48-6.97c0-9.57,7.76-17.33,17.33-17.33s17.33,7.76,17.33,17.33v6.96h-34.66v-6.96Zm36.57,22.38l-21.39,19.94c-.4,.37-1.01,.37-1.41,0l-12.99-12.35c-.41-.39-.43-1.04-.04-1.45l4.71-4.99c.39-.41,1.04-.43,1.45-.04l6.94,6.55c.39,.37,1.01,.37,1.41,0l15.22-14.14c.41-.39,1.06-.37,1.45,.04l4.7,4.98c.39,.41,.37,1.06-.04,1.45Z"/><g><path d="M115.84,3.36v7.92c-3-2.16-7.26-3.42-10.92-3.42-4.14,0-7.32,1.8-7.32,5.1,0,3.06,2.7,4.5,7.86,6.66,6.48,2.7,12.96,5.52,12.96,13.68s-6.6,13.68-15.9,13.68c-5.46,0-10.32-1.92-13.26-4.08v-8.46c3.12,2.94,7.92,5.04,12.54,5.04s7.98-2.22,7.98-5.88c0-3.36-3.18-4.98-8.46-7.26-5.88-2.46-12.06-5.34-12.06-13.02S95.5,.36,104.5,.36c4.44,0,8.46,1.26,11.34,3Z"/><path d="M126.22,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/><path d="M181.48,46.98c-12.12,0-22.74-9.18-22.74-23.34S169.36,.3,181.48,.3c5.16,0,9.06,1.38,12.12,3.06V11.82c-3.54-2.34-6.84-3.66-11.34-3.66-7.86,0-14.94,5.94-14.94,15.48s7.08,15.54,14.94,15.54c4.5,0,7.8-1.5,11.34-3.84v8.58c-3.06,1.68-6.96,3.06-12.12,3.06Z"/><path d="M201.1,28.62V1.32h8.4V28.74c0,6.6,3.6,10.5,9.48,10.5s9.84-3.9,9.84-10.56V1.32h8.4V28.62c0,10.8-7.02,18.42-18.24,18.42s-17.88-7.62-17.88-18.42Z"/><path d="M247.24,1.32h13.38c10.68,0,16.98,5.28,16.98,14.1,0,5.94-3.36,11.88-12.36,13.62l14.4,16.98h-10.26l-13.26-16.5h-.48v16.5h-8.4V1.32Zm12.84,21.6c6.06,0,9-2.7,9-7.02s-3.24-6.9-8.7-6.9h-4.74v13.92h4.44Z"/><path d="M286.24,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/></g><g><path d="M100.47,63.23v3.51c-1.33-.96-3.22-1.52-4.84-1.52-1.84,0-3.25,.8-3.25,2.26,0,1.36,1.2,1.99,3.48,2.95,2.87,1.2,5.74,2.45,5.74,6.06s-2.93,6.06-7.05,6.06c-2.42,0-4.57-.85-5.88-1.81v-3.75c1.38,1.3,3.51,2.23,5.56,2.23s3.54-.98,3.54-2.61c0-1.49-1.41-2.21-3.75-3.22-2.61-1.09-5.35-2.37-5.35-5.77s2.77-5.75,6.76-5.75c1.97,0,3.75,.56,5.03,1.33Z"/><path d="M116.06,63.23v3.51c-1.33-.96-3.22-1.52-4.84-1.52-1.84,0-3.25,.8-3.25,2.26,0,1.36,1.2,1.99,3.48,2.95,2.87,1.2,5.74,2.45,5.74,6.06s-2.93,6.06-7.05,6.06c-2.42,0-4.57-.85-5.88-1.81v-3.75c1.38,1.3,3.51,2.23,5.56,2.23s3.54-.98,3.54-2.61c0-1.49-1.41-2.21-3.75-3.22-2.61-1.09-5.35-2.37-5.35-5.77s2.77-5.75,6.76-5.75c1.97,0,3.75,.56,5.03,1.33Z"/><path d="M120.66,62.33h3.72v16.38h8.38v3.43h-12.1v-19.81Z"/><path d="M141.81,62.33h11.94v3.38h-8.22v4.81h7.53v3.14h-7.53v5.11h8.22v3.38h-11.94v-19.81Z"/><path d="M174.34,82.14h-3.51l-9.52-13.88h-.03v13.88h-3.59v-19.81h3.64l9.39,13.62h.03v-13.62h3.59v19.81Z"/><path d="M187.93,82.57c-5.37,0-10.08-4.07-10.08-10.35s4.71-10.35,10.08-10.35c2.29,0,4.02,.61,5.37,1.36v3.75c-1.57-1.04-3.03-1.62-5.03-1.62-3.48,0-6.62,2.63-6.62,6.86s3.14,6.89,6.62,6.89c2,0,3.46-.67,5.03-1.7v3.8c-1.36,.74-3.08,1.36-5.37,1.36Z"/><path d="M196.87,62.33h5.93c4.73,0,7.53,2.34,7.53,6.25,0,2.63-1.49,5.27-5.48,6.04l6.38,7.53h-4.55l-5.88-7.31h-.21v7.31h-3.72v-19.81Zm5.69,9.57c2.69,0,3.99-1.2,3.99-3.11s-1.44-3.06-3.86-3.06h-2.1v6.17h1.97Z"/><path d="M218.36,74.08l-7.34-11.76h4.18l5.05,8.4h.08l5-8.4h4.02l-7.29,11.73v8.08h-3.7v-8.06Z"/><path d="M231.77,62.33h5.53c5.21,0,8.33,2.58,8.33,6.78s-2.98,7.07-8.14,7.07h-2v5.96h-3.72v-19.81Zm5.9,10.48c2.5,0,4.2-1.3,4.2-3.56s-1.7-3.51-4.23-3.51h-2.15v7.07h2.18Z"/><path d="M252.97,65.73h-5.96v-3.4h15.61v3.4h-5.93v16.41h-3.72v-16.41Z"/><path d="M265.52,62.33h3.72v19.81h-3.72v-19.81Z"/><path d="M282.89,61.87c5.74,0,10.08,4.39,10.08,10.35s-4.33,10.37-10.08,10.37-10.13-4.39-10.13-10.37,4.36-10.35,10.13-10.35Zm6.3,10.35c0-4.36-3.08-6.89-6.3-6.89s-6.33,2.53-6.33,6.89,3.06,6.92,6.33,6.92,6.3-2.53,6.3-6.92Z"/><path d="M313.14,82.14h-3.51l-9.52-13.88h-.03v13.88h-3.59v-19.81h3.64l9.39,13.62h.03v-13.62h3.59v19.81Z"/></g><g><path d="M603.71,3.36v7.92c-3-2.16-7.26-3.42-10.92-3.42-4.14,0-7.32,1.8-7.32,5.1,0,3.06,2.7,4.5,7.86,6.66,6.48,2.7,12.96,5.52,12.96,13.68s-6.6,13.68-15.9,13.68c-5.46,0-10.32-1.92-13.26-4.08v-8.46c3.12,2.94,7.92,5.04,12.54,5.04s7.98-2.22,7.98-5.88c0-3.36-3.18-4.98-8.46-7.26-5.88-2.46-12.06-5.34-12.06-13.02s6.24-12.96,15.24-12.96c4.44,0,8.46,1.26,11.34,3Z"/><path d="M614.09,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/><path d="M669.35,46.98c-12.12,0-22.74-9.18-22.74-23.34S657.23,.3,669.35,.3c5.16,0,9.06,1.38,12.12,3.06V11.82c-3.54-2.34-6.84-3.66-11.34-3.66-7.86,0-14.94,5.94-14.94,15.48s7.08,15.54,14.94,15.54c4.5,0,7.8-1.5,11.34-3.84v8.58c-3.06,1.68-6.96,3.06-12.12,3.06Z"/><path d="M688.97,28.62V1.32h8.4V28.74c0,6.6,3.6,10.5,9.48,10.5s9.84-3.9,9.84-10.56V1.32h8.4V28.62c0,10.8-7.02,18.42-18.24,18.42s-17.88-7.62-17.88-18.42Z"/><path d="M735.11,1.32h13.38c10.68,0,16.98,5.28,16.98,14.1,0,5.94-3.36,11.88-12.36,13.62l14.4,16.98h-10.26l-13.26-16.5h-.48v16.5h-8.4V1.32Zm12.84,21.6c6.06,0,9-2.7,9-7.02s-3.24-6.9-8.7-6.9h-4.74v13.92h4.44Z"/><path d="M774.11,1.32h26.94v7.62h-18.54v10.86h16.98v7.08h-16.98v11.52h18.54v7.62h-26.94V1.32Z"/></g><g><path d="M577.36,62.33h5.53c5.21,0,8.32,2.58,8.32,6.78s-2.98,7.07-8.14,7.07h-2v5.96h-3.72v-19.81Zm5.9,10.48c2.5,0,4.2-1.3,4.2-3.56s-1.7-3.51-4.23-3.51h-2.15v7.07h2.18Z"/><path d="M606.4,82.14l-1.94-5.21h-7.77l-1.91,5.21h-3.88l7.53-19.81h4.28l7.61,19.81h-3.91Zm-3.03-8.35l-2.82-7.53-2.79,7.53h5.61Z"/><path d="M615.69,74.08l-7.34-11.76h4.18l5.05,8.4h.08l5-8.4h4.02l-7.29,11.73v8.08h-3.7v-8.06Z"/><path d="M630.34,82.14h-3.59l2.93-19.81h4.42l4.63,14.15h.03l4.5-14.15h4.39l2.9,19.81h-3.62l-1.89-14.65h-.08l-4.71,14.65h-3.22l-4.68-14.57h-.08l-1.92,14.57Z"/><path d="M653.99,62.33h11.94v3.38h-8.22v4.81h7.53v3.14h-7.53v5.11h8.22v3.38h-11.94v-19.81Z"/><path d="M686.52,82.14h-3.51l-9.52-13.88h-.03v13.88h-3.59v-19.81h3.64l9.39,13.62h.03v-13.62h3.59v19.81Z"/><path d="M695.38,65.73h-5.96v-3.4h15.61v3.4h-5.93v16.41h-3.72v-16.41Z"/></g><path d="M60.08,3.46C52.04,2.19,39.1,.31,33.47,.31S14.9,2.19,6.86,3.46C2.91,4.08,0,7.48,0,11.48V53.48c0,1.4,.55,2.74,1.53,3.73,2.77,2.79,18.6,17.17,26.89,24.67,2.87,2.6,7.23,2.6,10.1,0,8.3-7.51,24.17-21.92,26.89-24.67,.98-.99,1.53-2.33,1.53-3.73V11.48c0-4-2.91-7.4-6.86-8.03Zm-3.73,27.06l-25.98,24.22c-.48,.45-1.23,.45-1.71,0l-15.78-14.99c-.5-.47-.52-1.26-.05-1.76l5.72-6.05c.47-.5,1.26-.52,1.76-.05l8.43,7.96c.48,.45,1.23,.45,1.71,0l18.48-17.18c.5-.47,1.29-.45,1.76,.05l5.71,6.05c.47,.5,.45,1.29-.05,1.76Z"/></svg>
  </div>

  <div v-else-if="is_submitting_payment">
    <div class="program__card-errors" v-if="process_payment_error.length > 1">b: {{ process_payment_error }}</div>
    <div v-else>
      <div class="program__payment-message program__payment-message--italic">Processing payment. Please wait...</div>
      <div class='loading-bar program__loading-bar'>
        <div class='loading-bar__step'></div>
      </div>
    </div>
  </div>

  <div v-else-if="payment.has_error">
    <h3 class="program__payment-heading">Oops, error occurred</h3>
    <div class="program__payment-message program__payment-message--italic">
      <span style="font-style: italic; font-size: 0.8em;">{{ payment.error_message }}</span>
      <br />
      Please give Ash a call on <a href="tel:0410121754">0410 121 754</a> and we will get this fixed asap
    </div>
  </div>

  <div v-else-if="has_response_error">
    <h3 class="program__payment-heading">Oops, error occurred</h3>
    <div class="program__payment-message">
      {{ response_error_message }}
      <br />
      Please give Ash a call on <a href="tel:0410121754">0410 121 754</a> and we will get this fixed asap
    </div>
  </div>

  <div v-else >
    <div class="program__payment-message program__payment-message--italic">{{ payment.processing_message }}</div>
    <div class='loading-bar program__loading-bar'>
      <div class='loading-bar__step'></div>
    </div>
  </div>

  </form>

  </div>
  -->

</template>

<script>


import CheckoutStatus from "../../models/CheckoutStatus";
import CheckoutPayment from "../../models/CheckoutPayment";
import { loadStripe } from "@stripe/stripe-js";
import router from "../../router/router";

export default {
  data(){
    return{
      //stripe_publishable_key: 'pk_test_hV1WHXAjf4aTQ75AoGC4EbJT',
      stripe_publishable_key: 'pk_live_51JVXqBDf4Jq1MMu0Lgb8TizMmXZHEGtglSJ0oa10dpiBbpzzK1rIBvMWPyJgYG68ec6OnmCnH4zc19UZ5ov4umIh00GTM5XJYB',

      stripe: null,
      stripe_card: null,
      stripe_elements: null,

      checkout_status: null,
      checkout_status_subscription: null,

      is_card_mounted: false,
      is_submitting_payment: false,

      stripe_error: "",
      processing_error: "",

      card_settings: {
        hideIcon: false,
        hidePostalCode: true,
        style: {
          base: {
            color: '#00000',
            fontFamily: "'Montserrat', sans-serif",
            fontSmoothing: 'antialiased',
            fontSize: '15px',
            '::placeholder': {
              color: 'light gray',
              fontWeight: 300,
            },
            border: "solid 1px red",
            fontWeight: 400,
            lineHeight: 2.5,
            backgroundColor: '#fff'
          }
        }
      },
      stripe_appearance: {
        theme: 'stripe',
        variables: {
          colorPrimary: '#0570de',
          colorBackground: '#f0f0f0',
          colorText: '#30313d',
          colorDanger: '#df1b41',
          fontFamily: "'Montserrat', sans-serif",
          spacingUnit: '2px',
          borderRadius: '4px'
        }
      }

    }
  },

  async mounted(){
console.log("yy..1")
    this.checkout_status = await CheckoutStatus.forCheckoutID(this.checkout_id);
    console.log("yy..2")
    if(this.checkout_status == null ) {
      return;
    }else if(this.checkout_status.has_successful_payment || this.checkout_status.is_process_complete) {
      router.push(this.completion_path())
      return;
    }else if (this.checkout_status.has_error) {
      return;
    }else{
      this.checkout_status_subscription = CheckoutStatus.onChildDocumentUpdate(this.checkout_status.parent, this.checkout_status.document_id, this.checkoutStatus__updated);
      await this.setupStripe();
      this.mountCard();
    }

    /*
    this.payment = await Payment.get(this.payment_id);

  //  console.log("payment", payment)

    if(this.payment == null)
      return;

    if(this.payment.has_successful_payment) {
      window.localStorage.setItem('emailForSignIn', this.payment.email);
      console.log("stored email", window.localStorage.getItem('emailForSignIn'));

    }else if (this.payment.has_error == false ) {
      Payment.onDocumentUpdate(this.payment.document_id, this.payment__updated);
      await this.setupStripe();
     // this.createSubscription();
      this.mountCard();
    }*/
  },
  computed: {
    checkout_id() {
      return this.$route.params.checkout_id;
    },
    program(){
      return this.$parent.program;
    },
    design(){
      return this.$parent.design;
    },
  },
  methods:{
    async setupStripe () {
      this.stripe = await loadStripe(this.stripe_publishable_key);
    },
    mountCard () {
      if(this.stripe == null || this.is_card_mounted){
       // console.log("dont mount card")
        return;
      }

      this.is_card_mounted = true;

      this.$nextTick(() => {
       // console.log("mount card")
        this.stripe_elements = this.stripe.elements({ appearance: this.stripe_appearance });

        this.stripe_card = this.stripe_elements.create('card', this.card_settings);
        this.stripe_card.mount('#card-elements');
        this.stripe_card.on('change', this.stripeCard__didChange);
      });
    },



    // Stripe Events

    stripeCard__didChange(event) {
      //console.log("stripeCard__didChange", event)
      if (event.error) {
        this.is_submitting_payment = false;
        this.stripe_error = event.error.message;
      } else {
        this.stripe_error  = '';
      }
    },

    // User Events


    async paymentForm__submit(event) {
      this.processing_error = "";

      if (this.is_submitting_payment) return;
      this.is_submitting_payment = true;

      let response = await this.stripe.createToken(this.stripe_card);
      //console.log("... Stripe Token", response);

      if (response.error){
        this.is_submitting_payment = false;
        this.stripe_error = response.error.message;
      } else{
        await CheckoutPayment.create(this.checkout_id, response.token.id);
      }
    },

    /*
    charge(token){
      StripeAPI.charge({ payment_id: this.payment.document_id, stripe_token: token }).then(response => {
        //console.log("charge response: ", response);
        //this.button_text = "Processing. Please wait...";

      }).catch( error => {
        console.log("charge error", error);
        this.process_payment_error = "Error occurred processing payment.";
      });
    },*/



    // Model Events

    checkoutStatus__updated(checkout_status){
      console.log("status updated", checkout_status);

      this.checkout_status = checkout_status;

      if(this.checkout_status.has_error) {
        this.is_submitting_payment = false;
        this.processing_error = this.checkout_status.error_message;
      }

      if(this.checkout_status.has_successful_payment){
        this.is_submitting_payment = false;
        this.checkout_status_subscription();
        router.push(this.completion_path())
      }
    },

    // Utils

    completion_path(){
      return `/program/${this.program.document_id}/checkout/${this.checkout_id}/status`;
    },

  }
}
</script>